module.exports = __webpack_public_path__ + "img/shopdeal-01@2x.501d4dfa.png";